import { all, call, fork, put, takeEvery } from 'redux-saga/effects'

import {
  LOAD_DATA,
  SELEZIONA_DETTAGLIO_CRIMINE
} from 'Actions/ossif/ossifTypes'

import { selezionaDettaglioCrimine } from 'Actions'

export function* defCrimine(dettaglio) {
  yield put(selezionaDettaglioCrimine(dettaglio))
}

export function* setDettaglioCrimine(dettaglio) {
  yield put(selezionaDettaglioCrimine(dettaglio))

  //yield takeEvery(SELEZIONA_DETTAGLIO_CRIMINE, defCrimine(dettaglio));
}

function* printConsole({ payload }) {
  //console.clear();
  console.log('-----------------------redux saga------------------')
  console.log('dettaglio selezionato::', payload)
  //yield put(selezionaDettaglioCrimine(payload));
}

export function* selezionaDettaglioCrimineSaga() {
  yield takeEvery(SELEZIONA_DETTAGLIO_CRIMINE, printConsole)
}
/**
 * Dettaglio Crimine Root Saga
 */
export default function* rootSaga() {
  yield all([
    fork(setDettaglioCrimine)
    //fork(selezionaDettaglioCrimineSaga)
  ])
}
